import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6l16 0","key":"svg-0"}],["path",{"d":"M4 18l5 0","key":"svg-1"}],["path",{"d":"M4 12h13a3 3 0 0 1 0 6h-4l2 -2m0 4l-2 -2","key":"svg-2"}]]

const IconTextWrap = createReactComponent('outline', 'text-wrap', 'TextWrap', __iconNode);

export default IconTextWrap;